// extracted by mini-css-extract-plugin
module.exports = {"btn":"BrandCollectionButton_btn__3NZep","active":"BrandCollectionButton_active__oD9u1","inactive":"BrandCollectionButton_inactive__2lmjS"};